import React from "react";
import PropTypes from "prop-types";
const ShippingNoticeIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 28 26"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2 4h24v24H-2z" />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.257 10.097l7-2.8a2 2 0 0 1 1.486 0l7 2.8A2 2 0 0 1 19 11.954v8.092a2 2 0 0 1-1.257 1.857l-6.997 2.8a2 2 0 0 1-1.486 0l-7.003-2.8A2 2 0 0 1 1 20.046v-8.092a2 2 0 0 1 1.257-1.857z"
      />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        d="M.538 11.375L10 15.401l9.37-4.026"
      />
      <path
        fill={color || "var(--color-easil-gray-x-dark)"}
        d="M9 15h2v10H9z"
      />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        d="M15.083 8.93L5 13.246"
      />
      <g transform="translate(14 2)">
        <circle
          cx="6"
          cy="6"
          r="7"
          fill={color || "var(--color-easil-gray-x-dark)"}
          stroke="#FFFBFA"
          strokeWidth="2"
        />
        <path
          fill="#FFFBFA"
          fillRule="nonzero"
          d="M5.2 3a.8.8 0 1 1 1.6 0v3a.8.8 0 1 1-1.6 0V3z"
        />
        <circle cx="6" cy="8.8" r="1" fill="#FFF" />
      </g>
    </g>
  </svg>
);
ShippingNoticeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ShippingNoticeIcon;
